export const CARD_FORM_READY = 'StripeCardReady';
export const CARD_FORM_ERROR = 'StripeCardError';
export const GET_PAYMENT_TOKEN_COMPLETED = 'GetPaymentTokenCompleted';
export const CONNECT_BANK_ACCOUNT_COMPLETED = 'ConnectBankAccountCompleted';
export const GENERAL_ERROR = 'GeneralError';
export const CARD_VALIDATION_STATUS = 'CardValidationStatus';
